import { tween, styler } from 'popmotion';
import * as screenfull from 'screenfull';
import { HEAD_HEIGHT } from '../constants';
import { TIME_START } from '../content';

// ----------------------------------------------------
// Time
// ----------------------------------------------------

export const minutesToTimeString = minutes => {
  const mTotal = TIME_START.M + minutes;
  return `${TIME_START.H + Math.floor(mTotal / 60)}:${`0${mTotal % 60}`.slice(
    -2
  )}`;
};

// ----------------------------------------------------
// Resize
// ----------------------------------------------------

export const getWinWidth = () => Number(document.documentElement.clientWidth);
export const getWinHeight = () => Number(document.documentElement.clientHeight);

// ----------------------------------------------------
// Fullscreen
// ----------------------------------------------------

export const fsSwitch = () => {
  if (screenfull.enabled) {
    screenfull.toggle(document.getElementById('dukla'));
  }
};

// ----------------------------------------------------
// Scroll
// ----------------------------------------------------

let scrollTween = null;

export const scrollToTop = () => {
  if (window.scrollY !== HEAD_HEIGHT) {
    if (scrollTween !== null) {
      scrollTween.stop();
    }
    scrollTween = tween({
      from: window.scrollY,
      to: HEAD_HEIGHT,
      duration: 500,
    }).start(styler(window).set('scrollTop'));
  }
};



// WEBPACK FOOTER //
// ./src/utils/index.js